module.exports = __webpack_public_path__ + "img/Angiogenesis-ASHN_GSE227469.1d9308ab.png";